<template>
  <v-card v-if="$vuetify.breakpoint.smAndDown" flat class="transparent text--white align-center justify-center d-flex fill-height">
    <v-card fluid class="transparent mt-12" flat>
      <v-row>
        <v-img :src="require('@/assets/red_top.png')" width="100%" height="60" position="30%"></v-img>
      </v-row>
      <v-row class="align-center">
        <div class="red-background-mobile">
          <div class="headline text-left">
            <b v-html="$t('page3_home.text0')"></b>
          </div>
          <div class="text-left" style="font-size:18px" v-html="$t('page3_home.text1')"></div>
          <div class="text-left" style="font-size:18px" v-html="$t('page3_home.text2')"></div>
        </div>
      </v-row>
      <v-img :src="require('@/assets/red_bottom.png')" width="100%" height="60" position="30%"></v-img>
    </v-card>
    <!--<div class="arrow-go-down arrow-go-down-page3">-->
    <!--<v-img-->
    <!--:src="require('@/assets/arrow_down.png')"-->
    <!--height="20%"-->
    <!--style="cursor:pointer !important;"-->
    <!--contain-->
    <!--@click="scrolldown()"-->
    <!--/>-->
    <!--</div>-->
  </v-card>
  <v-card v-else flat class="transparent text--white align-center justify-center fill-height d-flex">
    <v-card fluid class="transparent" flat>
      <v-row>
        <img :src="require('@/assets/red_top.png')" :width="imageWidth" :height="imageHeight"/>
      </v-row>
      <v-row class="align-center">
        <div class="red-background">
          <div class="display-2 text-left">
            <b v-html="$t('page3_home.text0')"></b>
          </div>
          <br/>
          <div :class="textClass" v-html="$t('page3_home.text1')"></div>
          <div :class="textClass" v-html="$t('page3_home.text2')"></div>
        </div>
      </v-row>
      <v-img :src="require('@/assets/red_bottom.png')" :height="imageHeight" :width="imageWidth"></v-img>
    </v-card>
    <!--<div class="arrow-go-down arrow-go-down-page3">-->
      <!--<v-img-->
        <!--:src="require('@/assets/arrow_down.png')"-->
        <!--height="20%"-->
        <!--style="cursor:pointer !important;"-->
        <!--contain-->
        <!--@click="scrolldown()"-->
      <!--/>-->
    <!--</div>-->
  </v-card>
</template>
<script>
  export default {
    data: () => ({}),
    computed: {
      imageWidth() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return '180'
          case 'sm':
            return '130'
          case 'md':
            return '100%'
          case 'lg':
            return '100%'
          case 'xl':
            return '130%'
        }
      },
      imageHeight() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return '180'
          case 'sm':
            return '130'
          case 'md':
            return '80%'
          case 'lg':
            return '80%'
          case 'xl':
            return '80%'
        }
      },
      textClass() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return 'display-1 text-left'
          case 'sm':
            return 'display-1 text-left'
          case 'md':
            return 'title text-left'
          case 'lg':
            return 'display-1 text-left'
          case 'xl':
            return 'display-3 text-left'
        }
      }
    },
    methods: {
      scrolldown() {
        document
          .querySelector("#page4_home")
          .scrollIntoView({ behavior: "smooth" });
      }
    }
  };
</script>
